import { render } from "./MpfDetail.vue?vue&type=template&id=6e1e401e"
import script from "./MpfDetail.vue?vue&type=script&lang=js"
export * from "./MpfDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__